export const HEALTH_ASSESSMENT_IDS_DEV_METABOLIC = [
    "783",
    "784",
    "785",
    "786",
    "787",
    // "833",
    // "834",
    "838",
    "839",
    "840",
    "841",
    "842",
    "843",
    "790",
    "791",
    "844",
    "793",
    "797",
    "827",
    "828",
    "830",
    "845",
    "846",
    "847",
    "848",
    "849",
    "822",
    "850",
    "851",
    "852",
    "853",
    "854",
    "855",
    "856",
    "857",
    "831",
    "858",
    "859",
    "860",
    "861",
    "818",
    "808",
    "807",
    "863",
    "811",
    "810",
    "864",
    "865",
    // "866",
    "867",
    "868",
    "870",
    "871",
    "872",
    "873",
    "874",
    "832",
]

export const HEALTH_ASSESSMENT_IDS_PROD_METABOLIC = [
    "1",
    "2",
    "3",
    "4",
    "5",
    // "51",
    // "52",
    "53",
    "54",
    "6",
    "7",
    "55",
    "56",
    "57",
    "58",
    "59",
    "60",
    "61",
    "8",
    "9",
    "62",
    "11",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "45",
    "46",
    "48",
    "63",
    "64",
    "65",
    "66",
    "67",
    "40",
    "68",
    "69",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "49",
    "76",
    "77",
    "78",
    "79",
    "35",
    "37",
    "38",
    "39",
    "42",
    "43",
    "47",
    "36",
    "26",
    "25",
    "81",
    "29",
    "28",
    "82",
    "83",
    // "84",
    "85",
    "86",
    "27",
    "30",
    "31",
    "32",
    "33",
    "34",
    "87",
    "88",
    "89",
    "90",
    "91",
    "92",
    "50",
]